// extracted by mini-css-extract-plugin
export default {"checkbox":"SwitchRadioButton_checkbox__l4-8D","switch":"SwitchRadioButton_switch__1ufQS"};